import { combineReducers } from '@reduxjs/toolkit';
import { reducer as layout } from './layout';
import { reducer as sidebar } from './sidebar';

export const activeSession = combineReducers({
  layout,
  sidebar,
});
